export default "__VITE_ASSET__11b9891f__"